export default {
  development: 'http://localhost:3000',
  production: 'https://agronovabiotech.qmkey.com/backend',
};
